import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import {FaCalendarAlt} from 'react-icons/fa';

export const HistoricoJogos = () => {
    const [dias, setDias] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const carregarHistorico = async () => {
            try {
                setLoading(true);
                // Endpoint criado no passo 1
                const response = await fetch('/api/DiasDeJogo');
                if (!response.ok) {
                    throw new Error('Erro ao carregar histórico');
                }
                const data = await response.json();
                setDias(data);
            } catch (e) {
                console.error(e);
            } finally {
                setLoading(false);
            }
        };
        carregarHistorico();
    }, []);

    return (
        <div className="container py-3">
            <h2 className="fw-bold mb-4">Histórico de Jogos</h2>
            
            {loading && <p>Carregando histórico...</p>}
            
            {!loading && dias.length === 0 && (
                 <p className="text-muted">Nenhum dia de jogo encontrado.</p>
            )}

            <div className="row">
                <div className="col-12">
                    {dias.map(dia => (
                        <div key={dia.id} className="card mb-2 shadow-sm">
                            <div className="card-body">
                                <Link to={`/jogos-do-dia/${dia.id}`} className="text-decoration-none text-dark d-flex justify-content-between align-items-center">
                                    <div className="d-flex align-items-center">
                                        <FaCalendarAlt size={30} className="text-secondary me-3"/>
                                        <div>
                                            <h5 className="mb-1 fw-bold">{new Date(dia.data).toLocaleDateString('pt-BR')}</h5>
                                            <p className="mb-0 text-muted">
                                                {dia.quantidadeDeJogos || 0} jogos realizados
                                            </p>
                                        </div>
                                    </div>
                                    <div>
                                        {dia.status === 1 ? (
                                            <span className="badge bg-success">Finalizado</span>
                                        ) : (
                                            <span className="badge text-bg-warning">Em andamento</span>
                                        )}
                                    </div>
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            
            <div className="mt-3">
                <Link to="/" className="btn btn-secondary">Voltar para Home</Link>
            </div>
        </div>
    );
};